import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerMultiPromptTemplate,
  BackendMutationDeleteCustomerMultiPromptTemplateArgs,
} from 'src/types/backend';

import { FRAGMENT_MULTI_PROMPT_TEMPLATE } from './schema';

const MUTATION = gql`
  mutation DeleteCustomerMultiPromptTemplate($customerId: ID!, $id: ID!) {
    deleteCustomerMultiPromptTemplate(customerId: $customerId, id: $id) {
      ...CustomerMultiPromptTemplate
    }
  }
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
`;

type Variables = BackendMutationDeleteCustomerMultiPromptTemplateArgs;
type Result = BackendCustomerMultiPromptTemplate;

export const deleteCustomerMultiPromptTemplate = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
